import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { useListData, usePet, useToggle } from '../modules'

import { addOrderItem, clearOrder, modifyOrderItem, removeOrderItem } from '../store/actions'

import { SaleItem } from './NewOrder'

import OrderVariants from '../components/modals/ordervariants'
import Order from '../components/drawers/order'
import Receive from '../components/resusable/receive'

const AddToBill = () => {
    const { id, station: stat } = useParams()

    const [item, setItem] = useState(null)
    const [categories, setCategories] = useState([])
    const [category, setCategory] = useState(null)
    const [string, setString] = useState('')

    const dispatch = useDispatch()
    
    const history = useHistory()

    useEffect(() => {
        return () => {
            dispatch(clearOrder())
        }
    }, [])

    const [orderVisible, toggleOrderVisible] = useToggle()
    const [variantsModal, toggleVariantsModal] = useToggle()

    const { order } = useSelector(state => state.order)

    const [
        { loading: itemsLoading, error: itemsError, fetch: fetchItems }, 
        { list: saleItems }, 
        { Paginate }
    ] = useListData('saleItemsByStation', { 
        station: stat,
        category: category?.label,
        string,
     }, { notify: true }, 'items')

    const [, { list: serviceStations = [] }] = useListData('dispensingStations', null, { notify: true }, 'stations')
    const [{ loading: statLoading, error: statError, data: station }, refetchStation] = usePet('station', { id: stat }, { notify: true })

    const [, getCats] = usePet('saleItemCategoriesByStation', { station: stat }, { notify: true, callback: ({ data }) => setCategories(data) })

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            fetchItems()
    }

    const selectItem = itm => {
        setItem(itm)
        toggleVariantsModal()
    }

    const selectCategory = cat => {
        setCategory(cat)
        fetchItems()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="flex justify-center items-center mb-8">
                <input
                    onChange={ e => search(e.target.value) }
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-first-name"
                    type="text"
                    placeholder="Type to search items" />
            </div>
            {
                item &&
                <OrderVariants
                    item={item}
                    visible={variantsModal}
                    toggle={toggleVariantsModal} />
            }
            {
                station &&
                <Order
                    bill={ id }
                    station={ station }
                    visible={orderVisible}
                    toggle={toggleOrderVisible} />
            }
            <Receive
                loading={ statLoading }
                error={ statError }
                condition={ station }>
                <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                        <Select
                            value={{ label: station?.name, value: station?._id }}
                            onChange={ val => {
                                history.push(`/app/bills/add/${val.value}/${id}`)
                                refetchStation()
                                fetchItems()
                                getCats()
                            }}
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ serviceStations.map(stn => ({ label: stn.name, value: stn._id }))}
                            placeholder="Select Station" />
                        <h2 className="font-semibold text-gray-800">Items offered at { station?.name }</h2>
                        <Select
                            isClearable
                            value={ category }
                            onChange={ selectCategory }
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={categories.map(cat => ({ label: cat, value: cat }))}
                            placeholder="Select Category" />
                    </header>
                    <Receive
                        loading={ itemsLoading }
                        error={ itemsError }>
                        <div className="grid grid-cols-2 pb-7 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 mt-4 gap-x-4 gap-y-4 p-3 shadow-md hover:shodow-lg">
                            {
                                saleItems.map(({ name, variants, price, image, _id }, key) =>
                                    <SaleItem
                                        i={ key }
                                        item={{ name, variants, price, _id, image }}
                                        selectItem={selectItem}
                                        order={order} />)
                            }
                        </div>
                    </Receive>
                    { Paginate }
                </div>
            </Receive>
            {
                order?.length > 0 ?
                    <button onClick={toggleOrderVisible} className="p-0 text-white font-extrabold w-12 h-12 bg-red-600 rounded-full hover:bg-red-700 active:shadow-lg mouse fixed bottom-5 right-10 shadow transition ease-in duration-200 focus:outline-none">{order.length}</button>
                : null
            }
        </div>
    )
}

export default AddToBill